<template>
  <div>
    <div class="flex items-center text-stone-500 dark:text-stone-400 space-x-3">
      <!-- Mute icon -->
      <i class="fas fa-volume-mute text-xl"></i>

      <!-- Toggle switch -->
      <button @click="sound = !sound" :class="sound ? 'bg-blue-600' : 'bg-stone-300 dark:bg-stone-600'"
        class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
        <span :class="sound ? 'translate-x-6' : 'translate-x-1'"
          class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"></span>
      </button>

      <!-- Unmute icon -->
      <i class="fas fa-volume-up text-xl"></i>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { useWheelStore } from '@/stores/useWheelStore';
import * as Util from '@utils/Util.js';

const wheelStore = useWheelStore();

const wheelConfig = computed(() => wheelStore.wheelConfig);

const sound = ref(true);
const duringSpinSoundVolume = ref(0);
const afterSpinSoundVolume = ref(0);

watch(sound, (newValue) => {
  if (newValue) {
    Util.trackEvent('Wheel', 'Unmute');
    wheelStore.setVolumes({
      duringSpinSoundVolume: duringSpinSoundVolume.value,
      afterSpinSoundVolume: afterSpinSoundVolume.value
    });
  } else {
    Util.trackEvent('Wheel', 'Mute');
    duringSpinSoundVolume.value = wheelConfig.value.duringSpinSoundVolume;
    afterSpinSoundVolume.value = wheelConfig.value.afterSpinSoundVolume;
    wheelStore.setVolumes({
      duringSpinSoundVolume: 0,
      afterSpinSoundVolume: 0
    });
  }
});
</script>
